import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, IconButton, Menu, MenuItem, Box, Divider, useMediaQuery, useTheme } from "@mui/material";
import { format } from "date-fns";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom"; // Import for navigation

const Navbar = ({ toggleSidebar }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentTime, setCurrentTime] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    const updateTime = () => setCurrentTime(format(new Date(), "hh:mm:ss a EEEE, MMM dd, yyyy"));
    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  // New logout handler function
  const handleLogout = () => {
    // Clear any authentication tokens from localStorage
    localStorage.removeItem('authToken');
    // Clear any other user-related data
    localStorage.removeItem('userData');
    
    // Close the menu
    handleMenuClose();
    
    // Redirect to login page
    navigate('/login');
  };

  return (
    <AppBar position="fixed" sx={{ backgroundColor: "#2c2d2d" }}>
      <Toolbar sx={{ justifyContent: "space-between", fontFamily: "'Roboto', sans-serif" }}>
        {/* Logo Section */}
        <Box display="flex" alignItems="center">
          <img
            src="https://cdn.prod.website-files.com/6649a6fcf4ffc666ae869506/6790c2cc6c8bedb4eb7be57e_LOGO%20(4).png"
            alt="SaaSgenie Logo"
            style={{ width: 'auto', height: '40px', marginRight: '10px' }}
          />
        </Box>

        {/* Time and User Menu Section */}
        <Box display="flex" alignItems="center">
          {!isMobile && (
            <Typography
              variant="body1"
              sx={{
                marginRight: 2,
                color: "#fff",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              {currentTime}
            </Typography>
          )}

          {isMobile && (
            <IconButton
              onClick={toggleSidebar}
              sx={{
                color: "#fff",
                backgroundColor: "#2c2d2d",
                borderRadius: "8px",
                padding: "8px",
                "&:hover": {
                  backgroundColor: "#3c3c3c",
                },
              }}
            >
              <MenuIcon />
            </IconButton>
          )}

          <IconButton
            onClick={handleMenuOpen}
            sx={{
              color: "#fff",
              backgroundColor: "#2c2d2d",
              borderRadius: "8px",
              padding: "8px",
              "&:hover": {
                backgroundColor: "#3c3c3c",
              },
            }}
          >
            <PersonIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#fff",
                color: "#000",
                borderRadius: "8px",
                boxShadow: 3,
                fontFamily: "'Roboto', sans-serif",
              },
            }}
          >
            <MenuItem
              onClick={handleMenuClose}
              sx={{
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
                width: "200px",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Profile
            </MenuItem>
            <MenuItem
              onClick={handleMenuClose}
              sx={{
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
                width: "200px",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                fontFamily: "'Roboto', sans-serif",
              }}
            >
              Settings
            </MenuItem>
            <Divider sx={{ borderColor: "#ddd" }} />
            <MenuItem
              onClick={handleLogout} // Changed to use the new logout handler
              sx={{
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                },
                width: "200px",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                fontFamily: "'Roboto', sans-serif",
                color: "#ff4444", // Added red color for logout
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;